import { takeLatest, put } from 'redux-saga/effects';
import { SET_RESULTS, SET_SELECTED_DATE, setResults } from '../reducers/results';

// TODO Just a temporary saga that sets the results in the reducer.  Not going to test this thing.
export const SAGA_UPDATE_RESULTS = 'SAGA_UPDATE_RESULTS';

export function updateResults(resultsArray) {
  return { type: SET_RESULTS, payload: resultsArray };
}

export function updateResultsSelectedDate(date) {
  return { type: SET_SELECTED_DATE, payload: date };
}

export function* setResultsSaga(action) {
  yield put(setResults(action.payload));
}

export function* watchForSetResults() {
  yield takeLatest(SAGA_UPDATE_RESULTS, setResultsSaga);
}
